module.exports = __webpack_public_path__ + "img/header_img7.4dc6a31a.png";